import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer
      data-platform="true"
      className="text-white relative overflow-hidden"
      style={{ backgroundColor: 'var(--visitor-accent)' }}
    >
      {/* Dotted overlay pattern */}
      <div
        className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.5) 1px, transparent 1px)',
          backgroundSize: '10px 10px',
        }}
      />
      <div className="absolute -top-12 -left-8 w-48 h-48 rounded-full bg-white/10 blur-3xl float-y pointer-events-none" />
      <div className="absolute -bottom-16 right-4 w-56 h-56 rounded-full bg-white/10 blur-3xl float-y pointer-events-none" style={{ animationDelay: '1.5s' }} />
      <div className="relative px-5 sm:px-8 lg:px-10 py-10 sm:py-12 lg:py-14 grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10">
        <div className=" text-[24px] sm:text-[28px] lg:text-[34px] leading-[1.15] max-w-md">
          Discoveries are out there, waiting to be made.
          <br />
          Why not <em className="italic">by you</em>?
        </div>
        <div className="grid grid-cols-2 gap-6 text-[11px] sm:text-[11.5px] uppercase tracking-wider self-end">
          <ul className="space-y-3">
            <li><a href="mailto:manishapundirdesign@gmail.com" className="footer-link opacity-90">Email</a></li>
            <li><a href="https://www.linkedin.com/in/manishapundir/" target="_blank" rel="noopener noreferrer" className="footer-link opacity-90">LinkedIn</a></li>
            <li><a href="/ManishaPundirResume.pdf" target="_blank" rel="noopener noreferrer" className="footer-link opacity-90">Resume</a></li>
          </ul>
          <ul className="space-y-3">
            <li><Link to="/home" className="footer-link opacity-90">Home</Link></li>
            <li><Link to="/about" className="footer-link opacity-90">About Me</Link></li>
            <li><Link to="/sketchbook" className="footer-link opacity-90">Sketchbook</Link></li>
            <li><Link to="/visitor-gallery" className="footer-link opacity-90">Visitor Gallery</Link></li>
            <li className="pt-3"><Link to="/" className="footer-link opacity-90">✦ Back to Space</Link></li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
